<template>
  <div class="chat-recovery-loader">
    <loader :show="true"></loader>
  </div>
</template>

<script>
import Loader from '../../../packages/vue-advanced-chat/src/ChatWindow/Loader.vue';

export default {
  name: 'ChatRecoveryLoader',
  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
.chat-recovery-loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  min-height: 200px;
}
</style>
